import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=6c2a9295&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=6c2a9295&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a9295",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2a9295')) {
      api.createRecord('6c2a9295', component.options)
    } else {
      api.reload('6c2a9295', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=6c2a9295&scoped=true", function () {
      api.rerender('6c2a9295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/emegroup/Create.vue"
export default component.exports